export const features =  {
    AdminEdits:true,
    AllCountries:true,
    WithWebsitePages:true,
    MobileLogin:true,
    FacebookLogin:false,
    AppleLogin:false
};